import React from 'react';
import { Ruler, Truck, Clock, CloudRain } from 'lucide-react';
export function ScopeImpactSection() {
  return <section className="py-16 bg-slate-50 md:py-24" data-id="element-764">
      <div className="container mx-auto px-4 md:px-6" data-id="element-765">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-766">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-767">
            How Material Choice Affects Your Project
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-768">
            Understanding scope before you get surprised.
          </p>
        </div>

        <div className="overflow-x-auto bg-white rounded-xl shadow-sm border border-slate-200" data-id="element-769">
          <table className="w-full text-sm text-left border-collapse min-w-[600px]" data-id="element-770">
            <thead data-id="element-771">
              <tr className="bg-slate-50 border-b border-slate-200" data-id="element-772">
                <th className="p-4 font-semibold text-slate-900 w-1/4" data-id="element-773">
                  Factor
                </th>
                <th className="p-4 font-semibold text-slate-900 w-1/4 border-l border-slate-200" data-id="element-774">
                  Concrete
                </th>
                <th className="p-4 font-semibold text-slate-900 w-1/4 border-l border-slate-200" data-id="element-775">
                  Pavers
                </th>
                <th className="p-4 font-semibold text-slate-900 w-1/4 border-l border-slate-200" data-id="element-776">
                  Asphalt
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-777">
              <tr data-id="element-778">
                <td className="p-4 font-medium text-slate-700 flex items-center gap-2" data-id="element-779">
                  <Ruler className="h-4 w-4 text-slate-400" data-id="element-780" /> Excavation Depth
                </td>
                <td className="p-4 text-slate-600 border-l border-slate-200" data-id="element-781">
                  8-10 inches
                </td>
                <td className="p-4 text-slate-600 border-l border-slate-200" data-id="element-782">
                  10-12 inches
                </td>
                <td className="p-4 text-slate-600 border-l border-slate-200" data-id="element-783">
                  8-10 inches
                </td>
              </tr>
              <tr data-id="element-784">
                <td className="p-4 font-medium text-slate-700 flex items-center gap-2" data-id="element-785">
                  <Truck className="h-4 w-4 text-slate-400" data-id="element-786" /> Tear-Out
                </td>
                <td className="p-4 text-slate-600 border-l border-slate-200" data-id="element-787">
                  Heavy disposal cost
                </td>
                <td className="p-4 text-slate-600 border-l border-slate-200" data-id="element-788">
                  Reusable if careful
                </td>
                <td className="p-4 text-slate-600 border-l border-slate-200" data-id="element-789">
                  Moderate cost
                </td>
              </tr>
              <tr data-id="element-790">
                <td className="p-4 font-medium text-slate-700 flex items-center gap-2" data-id="element-791">
                  <Clock className="h-4 w-4 text-slate-400" data-id="element-792" /> Timeline Impact
                </td>
                <td className="p-4 text-slate-600 border-l border-slate-200" data-id="element-793">
                  + Curing time (3-7 days)
                </td>
                <td className="p-4 text-slate-600 border-l border-slate-200" data-id="element-794">
                  Labor intensive laying
                </td>
                <td className="p-4 text-slate-600 border-l border-slate-200" data-id="element-795">
                  Fast install (1-2 days)
                </td>
              </tr>
              <tr data-id="element-796">
                <td className="p-4 font-medium text-slate-700 flex items-center gap-2" data-id="element-797">
                  <CloudRain className="h-4 w-4 text-slate-400" data-id="element-798" /> Weather
                  Windows
                </td>
                <td className="p-4 text-slate-600 border-l border-slate-200" data-id="element-799">
                  Needs 5°C+
                </td>
                <td className="p-4 text-slate-600 border-l border-slate-200" data-id="element-800">
                  Flexible
                </td>
                <td className="p-4 text-slate-600 border-l border-slate-200" data-id="element-801">
                  Needs warm & dry
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center mt-8" data-id="element-802">
          <p className="text-sm text-slate-500 italic bg-white inline-block px-4 py-2 rounded-full border border-slate-200" data-id="element-803">
            We spell this out upfront so there are no surprises on install day.
            Your site visit quote includes all of this.
          </p>
        </div>
      </div>
    </section>;
}